import React, { useCallback, useRef, useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Fieldset } from 'primereact/fieldset';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import api from '../api/api';
import { ErrorValidationMessage } from './ErrorValidationMessage';

import '../layout/sass/_form.scss';

export const FormLojaItens = ({ isLoading, setLojaItens, produtos }) => {

    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false)
    const [municipios, setMunicipios] = useState([])
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const schema = Yup.object().shape({
        quantidade: Yup
            .number()
            .required("A quantidade é obrigatório")
            .max(10000, "A quantidade dete ter no máximo 10 caracteres"),
        produtoId: Yup
            .number()
            .nullable()
            .required("O produto é obrigatório")
            .positive("O produto deve ser selecionado")
            .integer("O produto deve estar na lista"),
        municipioId: Yup
            .number()
            .nullable()
            .required("O municipio é obrigatório")
            .positive("O municipio deve ser selecionado")
            .integer("O municipio deve estar na lista"),
    })

    const formik = useFormik({

        initialValues: {
            "id": null,
            "produtoId": null,
            "produtoNome": "",
            "quantidade": 0,
            "lojaId": null,
            "municipioId": null,
            "municipioNome": "",
            "itensId": ""
        },

        validationSchema: schema,

        enableReinitialize: false,

        onSubmit: (data) => {
            setIsSubmiting(true)

            let produtoNome
            produtos.forEach((p) => {
                if (p.value === data.produtoId) {
                    produtoNome = p.label
                }

            })
            data.produtoNome = produtoNome;
            let municipioNome
            municipios.forEach((p) => {
                if (p.value === data.municipioId) {
                    municipioNome = p.label
                }

            })
            data.municipioNome = municipioNome;

            setLojaItens(lojaItens => [...lojaItens, data]);
            formik.resetForm()
            formik.setFieldValue("municipioId", data.municipioId)
            setIsSubmiting(false)
        }
    })
    
    const getMunicipios = useCallback(async () => {
        try {
            const response = await api.get(`municipio/findAllBasic`);
            setMunicipios(response.data.map(i => {
                var prod = {label: '', value: ''};
                prod.label = i.nome 
                prod.value = i.id 
                return prod
            }))
        }
        catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao obter municipios', detail: error.toString() });
        }
    }, []);

    useEffect(() => {

        async function loja() {
            await getMunicipios();
        };
        loja();
    }, [getMunicipios])

    return (

        <Fieldset legend="Itens" toggleable  >
            <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
                <Toast ref={toast} position="bottom-right" />
                <div className="p-col-12">

                    <form onSubmit={formik.handleSubmit}>
                        <div className="p-formgrid p-grid p-fluid p-mx-0">

                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="produto"
                                    className={classNames({ 'p-error': isFormFieldValid('produto') })}
                                >
                                    Municipio
                                </label>
                                {
                                    !isLoading ?
                                        <Dropdown
                                            id="municipioId"
                                            name="municipioId"
                                            options={municipios}
                                            filter={true}
                                            emptyMessage={"Nenhum municipio encontrado"}
                                            placeholder="Selecione um municipio"
                                            className={classNames({ 'p-invalid': isFormFieldValid('municipioId') })}
                                            value={formik.values.municipioId}
                                            onChange={option => formik.setFieldValue("municipioId", option.value)}                                     
                                            emptyFilterMessage={"Nenhum municipio encontrado"}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.municipioId && formik.touched.municipioId &&
                                    <ErrorValidationMessage message={formik.errors.municipioId} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="produtoId"
                                    className={classNames({ 'p-error': isFormFieldValid('produtoId') })}
                                >
                                    Produto
                                </label>
                                {
                                    !isLoading ?
                                        <Dropdown
                                            id="produtoId"
                                            name="produtoId"
                                            options={produtos}
                                            filter={true}
                                            emptyMessage={"Nenhum produto encontrado"}
                                            placeholder="Selecione um produto"
                                            className={classNames({ 'p-invalid': isFormFieldValid('produtoId') })}
                                            value={formik.values.produtoId}
                                            onChange={option => formik.setFieldValue("produtoId", option.value)}                                     
                                            emptyFilterMessage={"Nenhum produto encontrado"}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.produtoId && formik.touched.produtoId &&
                                    <ErrorValidationMessage message={formik.errors.produtoId} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="quantidade"
                                    className={classNames({ 'p-error': isFormFieldValid('quantidade') })}
                                >
                                    Quantidade
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="quantidade"
                                            name="quantidade"
                                            type="number"
                                            className={classNames({ 'p-invalid': isFormFieldValid('quantidade') })}
                                            value={formik.values.quantidade}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.quantidade && formik.touched.quantidade &&
                                    <ErrorValidationMessage message={formik.errors.quantidade} />
                                }
                            </div>

                            <div className="p-d-flex p-jc-end p-sm-12">

                                <Button
                                    icon="pi pi-plus"
                                    type="button"
                                    iconPos="right"
                                    onClick={formik.handleSubmit}
                                    loading={isSubmiting}
                                />
                            </div>

                            <div className="p-formgrid p-grid p-fluid p-mx-0">

                            </div>

                        </div>

                    </form>
                </div>
            </div>

        </Fieldset>

    );
}
